import totalBobble from '../assets/images/marblesLegend/bobbleTotal.svg'
import highBobble from '../assets/images/marblesLegend/bobbleHigh.svg'
import mediumBobble from '../assets/images/marblesLegend/bobbleMedium.svg'
import lowBobble from '../assets/images/marblesLegend/bobbleLow.svg'
import neutralBobble from '../assets/images/marblesLegend/bobbleNeutral.svg'
import { RISK_TYPE } from './chart-d3-utils'

const generateRiskCounts = (tickers, riskType) =>
  [
    {
      index: 0,
      cx: 229,
      cy: 30,
      name: 'total',
      title: 'Total',
      color: '#1D82F9',
      colorBorder: '#A3CCFB',
      bobbleImg: totalBobble,
    },
    {
      index: 1,
      cx: 162.044,
      cy: 134,
      name: 'Fire',
      title: 'Fire',
      color: '#DE1313',
      colorBorder: '#F5A6A6',
      bobbleImg: highBobble,
    },
    {
      index: 2,
      cx: 136.044,
      cy: 259,
      name: 'Smoke',
      title: 'Smoke',
      color: '#ED5F5F',
      colorBorder: '#FBD4D5',
      bobbleImg: mediumBobble,
    },
    {
      index: 3,
      name: 'Watchlist',
      title: 'Watchlist',
      color: '#E39193',
      colorBorder: '#E8A6A7',
      cx: 162.044,
      cy: 387,
      bobbleImg: lowBobble,
    },
    {
      index: 4,
      name: 'Neutral',
      title: 'Neutral',
      color: '#BBBFC7',
      colorBorder: '#FFFFFF',
      cx: 230.044,
      cy: 488,
      bobbleImg: neutralBobble,
    },
  ].map(d => {
    if (d.title === 'Total') {
      return { ...d, value: 0, count: tickers.length }
    }
    const num = tickers.filter(t =>
      riskType === RISK_TYPE.CREDIT
        ? t.credit_status === d.name
        : t.risk_outlook === d.name,
    ).length
    const equityRiskNumber = tickers.filter(t => t.risk_outlook === d.name).length
    const creditRiskNumber = tickers.filter(t => t.credit_status === d.name)
      .length
    return { ...d, value: num, count: num, equityRiskNumber, creditRiskNumber }
  })

export default generateRiskCounts
